export default __webpack_public_path__ + "images/dcd9536cbac866044b1d8dffb31c9873-nonpartisan.jpg";